import angular from 'angular';
import ngRoute from 'angular-route';
import ngCookies from 'angular-cookies';
import ngAnimate from 'angular-animate';
import ngRedux from 'ng-redux';
import { notification } from 'antd';

import * as rs from './store';
import { rootReducer } from './store/reducers'
import * as _ from 'lodash';
import axios from 'axios';

import createSagaMiddleware from 'redux-saga';
import { rootSaga } from './store/sagas';

const sagaMiddleware = createSagaMiddleware();

// handle redirect for client and mobile workflow OIDC auth //
/************************************************/
if(localStorage.getItem('oidcRedirect')) {
  const { clientId, tenantId } = JSON.parse(localStorage.getItem('oidcRedirect'));
  const msalObject = window.dl.createMSALObject(clientId, tenantId);
  localStorage.removeItem('oidcRedirect');
  msalObject.handleRedirectPromise();
}
/************************************************/

global.loginPages = ['/login'];
global.webTools = angular.module('webTools',
  [ngRoute,
    ngCookies,
    ngAnimate,
    ngRedux,
    'kendo.directives',
    'flow',
  ]);

// register the interceptor as a service
angular.module('webTools').factory('wtHttpInterceptor', ['$q', '$injector', '$location', '$rootScope', '$ngRedux',
  function ($q, $injector, $location, $rootScope, $ngRedux) {

    var _popupTimer = '';
    var _logoutTimer = '';

    var clearTimers = function () {
      window.clearTimeout(_popupTimer);
      window.clearTimeout(_logoutTimer);
    };

    var logout = function () {
      clearTimers();
      window.onbeforeunload = undefined;
      $location.url('/logout');
      $rootScope.$apply();
    }

    var showPopup = function () {
      $injector.get('ModalWindow').openConfirmation("Your session is about to expire.<br><br>Stay logged in?", stayAlive, logout);
    }

    var stayAlive = function () {
      $injector.get('$http').get('/api/authentication/KeepSessionAlive');
    }

    const resetSessionTimers = () => {

      const loggedIn = $injector.get('Auth').loggedIn();
      const sessionTimeout = $injector.get('Auth').getTimeout() * 60000
      const alertTimeout = sessionTimeout - 120000;

      if (loggedIn) {
        if (sessionTimeout > 0 && $location.path() !== '/logout') {
          clearTimers();
          _popupTimer = window.setTimeout(showPopup, alertTimeout);
          _logoutTimer = window.setTimeout(logout, sessionTimeout);
        }
      } else {
        clearTimers();
      }

    }

    // make sure React is resetting the timer
    axios.interceptors.response.use(function (response) {
      resetSessionTimers();
      return response;
    }, function (error) {
      return Promise.reject(error);
    });

    // Electron
    axios.interceptors.request.use(function (request) {
      const state = $ngRedux.getState();
      if (request.url.indexOf('/api/') > -1 && state.app.endpoint) {
        request.url = state.app.endpoint + request.url
      }
      return request;
    }, function (error) {
      return Promise.reject(error);
    });

    return {
      // optional method
      'request': function (request) {

        const state = $ngRedux.getState();

        let tokenPromise = $q.when($injector.invoke(() => { }, this, {
          options: request
        }));

        return tokenPromise.then(function (token) {
          if (request.url.indexOf('/api/') > -1 && state.app.endpoint) {
            request.url = state.app.endpoint + request.url
          }
          return request;
        });
      },

      // optional method
      'requestError': function (rejection) {
        return $q.reject(rejection);
      },

      // optional method
      'response': function (response) {

        resetSessionTimers();

        return response || $q.when(response);
      },

      // optional method
      'responseError': function (rejection) {

        if (rejection.status === 401) {
          window.location.href = '/';
        }

        return $q.reject(rejection);
      }
    };
  }
]);

angular.module('webTools').config(['$routeProvider', '$httpProvider', '$locationProvider', '$ngReduxProvider',
  function ($routeProvider, $httpProvider, $locationProvider, $ngReduxProvider) {

    // Create Redux store
    if (window.__REDUX_DEVTOOLS_EXTENSION__) {
      $ngReduxProvider.createStoreWith(rootReducer, [sagaMiddleware], [window.__REDUX_DEVTOOLS_EXTENSION__()]);
    } else {
      $ngReduxProvider.createStoreWith(rootReducer, [sagaMiddleware]);
    }

    // no hash in URL
    $locationProvider.html5Mode(true);

    // global config for notifications
    notification.config({
      placement: 'bottomRight'
    });

    //$locationProvider.hashPrefix('');
    $httpProvider.interceptors.push('wtHttpInterceptor');

    $routeProvider.when('/documents/:folder?',
      {
        templateUrl: '/partials/documents.html',
        controller: 'DocumentsCtrl',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'documents');
              } else {
                return checkPermissions($q, $rootScope, $location, $ngRedux, Auth, 'documents');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/workflow',
      {
        templateUrl: '/partials/workflow.html',
        controller: 'WorkflowCtrl',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'workflow');
              } else {
                return checkPermissions($q, $rootScope, $location, $ngRedux, Auth, 'workflow');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/search',
      {
        templateUrl: '/partials/search.html',
        controller: 'SearchCtrl',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'search');
              } else {
                return checkPermissions($q, $rootScope, $location, $ngRedux, Auth, 'search');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/saved-search',
      {
        templateUrl: '/partials/saved-search.html',
        controller: 'SavedSearchCtrl',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'search');
              } else {
                return checkPermissions($q, $rootScope, $location, $ngRedux, Auth, 'search');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/projects',
      {
        templateUrl: '/partials/projects.html',
        controller: 'ProjectsCtrl',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'projects');
              } else {
                return checkPermissions($q, $rootScope, $location, $ngRedux, Auth, 'projects');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/reports',
      {
        templateUrl: '/partials/reports.html',
        controller: 'ReportsCtrl',
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'reports');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/portal',
      {
        templateUrl: '/partials/portal.html',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'portal');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/configuration/:view?',
      {
        templateUrl: '/partials/configuration.html',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'ModalWindow',
            function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow) {
              if (!Auth.loggedIn()) {
                return loadSession($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, 'documents');
              }
            }
          ]
        }
      }
    );
    $routeProvider.when('/logout',
      {
        templateUrl: '/partials/logout.html',
        caseInsensitiveMatch: true
      }
    );
    $routeProvider.when('/login/:loginPath?',
      {
        templateUrl: '/partials/login.html',
        reloadOnSearch: false,
        caseInsensitiveMatch: true,
        resolve: {
          sessionCheck: ['$q', '$location', '$rootScope', '$ngRedux', 'Auth', 'Utility', function ($q, $location, $rootScope, $ngRedux, Auth, Utility) {
            return window.loadLogin($q, $location, $rootScope, $ngRedux, Auth, Utility);
          }]
        }
      }
    );

    $routeProvider.otherwise({ redirectTo: () => `/login${window.location.search}` });
  }
]).run(['$rootScope', '$location', '$ngRedux', '$window', '$timeout', '$cookies', 'Auth',
  function ($rootScope, $location, $ngRedux, $window, $timeout, $cookies, Auth) {

    // this is for the OIDC login from the thick client
    const clientObject = JSON.parse(sessionStorage.getItem('client-login-object'));

    // this is for the OIDC login from mobile
    const oidcAuto = sessionStorage.getItem('mobile-oidc-auto');
    const oidcPath = sessionStorage.getItem('mobile-oidc-path');
    const oidcServer = sessionStorage.getItem('mobile-oidc-server');
    const oidcRepository = sessionStorage.getItem('mobile-oidc-repository');
    const oidcRedirect = decodeURIComponent(sessionStorage.getItem('mobile-oidc-redirect'));

    if (clientObject) {
        $rootScope.$on('$routeChangeStart', (event) => {
            event.preventDefault()
        })

        const msalObject = window.dl.createMSALObject(clientObject.clientId, clientObject.tenantId);

        const handleResponse = (response) => {
            if (response !== null) {
                Auth.clientSSOLogin('oidc', clientObject.dlClientId, clientObject.server, clientObject.repository, response.idToken, clientObject.isEdit, clientObject.loginPath, (authorized, data) => {
                    sessionStorage.removeItem('client-login-object');
                    window.location.href = 'sso-complete.html';
                    return;
                });
            }
        }

        msalObject.handleRedirectPromise().then(handleResponse);

        return;
    }

    if (oidcPath) {
      
      $rootScope.$on('$routeChangeStart', (event) => {
        event.preventDefault()
      })

      Auth.loadSettings(true, (data) => {
        const msalConfig = {
          auth: {
            clientId: data.clientId,
            authority: `https://login.microsoftonline.com/${data.tenantId}/`,
            redirectUri: new $window.URL($location.absUrl()).origin // get base URL
          },
          cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
          }
        };

        const loginRequest = {
          scopes: ["User.Read"]
        };

        const msalObject = new msal.PublicClientApplication(msalConfig);

        function handleResponse(response) {

          if (response !== null) {

            Auth.login(oidcPath, 'mobile-oidc', '', '', '', oidcServer, oidcRepository, '', response.idToken, (authorized, redirect, message) => {

              sessionStorage.removeItem('mobile-oidc-auto');
              sessionStorage.removeItem('mobile-oidc-path');
              sessionStorage.removeItem('mobile-oidc-server');
              sessionStorage.removeItem('mobile-oidc-repository');
              sessionStorage.removeItem('mobile-oidc-redirect');

              if (!authorized) {
                var cName = oidcAuto == 'true' ? 'azureAutoError' : 'loginError';
                var cMessage = oidcAuto == 'true' ? true : message ? message : 'Login failed';
                document.cookie = `${cName}=${cMessage}; path=/`;
              }

              window.location.href = `/mobile/login/${oidcPath}${oidcRedirect}`;
              return;
            });
          }
          else {
            msalObject.loginRedirect(loginRequest);
          }
        }

        msalObject.handleRedirectPromise().then(handleResponse);

        return;
      });
    }
    else {
      window.dl = window.dl || {};

      window.addEventListener('message', (event) => {
        if (event.source !== window) return
        if (event.data.type === 'downloadComplete') {
          console.log(event)
        }
      })

      window.relayMessage = (message) => {
        window.postMessage(message);
      }

      // Set the store for React
      rs.setReactStore($ngRedux);

      // Run Saga
      sagaMiddleware.run(rootSaga);

      window.dl.logout = () => {
        axios.get('/api/authentication/logout')
          .then(() => { window.postMessage({ action: 'logged-out', payload: 'loggedout' }) })
          .catch(() => { window.postMessage({ action: 'logged-out', payload: 'logout-failed' }) })
      }

      // Angular will listen for change events
      $ngRedux.subscribe(() => {
        $timeout(() => { $rootScope.$apply(() => { }) }, 100);
      });

      var mobile = isMobile(navigator.userAgent || navigator.vendor || window.opera);
      var q = $location.$$absUrl.indexOf('?') > -1 ? $location.$$absUrl.substr($location.$$absUrl.indexOf('?')) : '';
      var u = '/mobile/login' + q;

      // redirect login page to mobile
      if (_.indexOf($location.path(), '/login/')) {
        u = `/mobile${$location.path()}${q}`;
      }

      if (mobile) {
        if ($cookies.bypassMobile) {
          if ($cookies.bypassMobile !== 'true') {
            $window.location.href = u;
          }
        } else {
          $window.location.href = u;
        }
      }

      // SETTING MOVED TO LOCAL STORAGE BUT COOKIE CURRENTLY NEEDED FOR LINK SUPPORT
      var pageSize = localStorage.getItem('pageSize');

      if (pageSize) {
        $cookies.put('pageSize', pageSize);
      }
    }
  }
]);

global.sendToDefaultView = function ($ngRedux, $location, Auth) {
  var nodes = Auth.getAllowedNodes();

  const store = $ngRedux.getState();
  let view = store.app.defaultView;

  if (nodes.length > 0) {
    if (!_.includes(nodes, view === 'messages' ? 'workflow' : view)) {
      view = nodes[0];
    } else {
      switch (store.app.defaultView) {
        case 'messages':
          view = 'workflow?view=messages'
          break;
        case 'workflow':
          view = 'workflow?view=tasks'
          break;
        default:
          view = store.app.defaultView;
          break;
      }
    }
  }

  $location.url('/' + view);
}

global.loadLogin = function ($q, $location, $rootScope, $ngRedux, Auth, Utility) {

  var defer = $q.defer();
  const store = $ngRedux.getState();

  isMobile(navigator.userAgent || navigator.vendor || window.opera) && defer.reject();

  Auth.loadSettings(true, () => {
    Auth.checkSession(function (loggedIn) {

      if (!loggedIn) {
        defer.resolve();
        return;
      } else {
        // check for link
        if (!_.isEmpty($location.search())) {
          const link = Utility.buildWebLink($location.search());

          if (link) {
            Utility.getWebLinkPath(link).then((res) => {
              $location.url(res.linkPath);
            })
          }
        } else {
          if (store.app.redirect) {
            $location.url(store.app.redirect);
            delete $ngRedux.get('redirect');
            defer.resolve()
          } else {
            window.sendToDefaultView($ngRedux, $location, Auth);
          }
        }
      }
    });
  });

  return defer.promise;
}

const loadSession = function ($q, $location, $rootScope, $ngRedux, Auth, ModalWindow, node) {

  var defer = $q.defer();

  Auth.loadSettings(false, () => {
    Auth.checkSession(function (loggedIn) {
      if (!loggedIn) {
        $location.url(`/login?redirect=${$location.url()}`);
      } else {
        $rootScope.$broadcast('userUpdated');
        if (!_.includes(Auth.getAllowedNodes(), node)) {
          defer.reject();
          ModalWindow.openNotification('You do not have access to view this link.', function () {
            window.sendToDefaultView($ngRedux, $location, Auth);
          })
        } else {
          defer.resolve();
        }
      }
    });
  })

  return defer.promise;
}

const checkPermissions = function ($q, $rootScope, $location, $ngRedux, Auth, node) {
  var defer = $q.defer();

  if (_.includes(Auth.getAllowedNodes(), node)) {
    defer.resolve();
  } else {
    defer.reject();
    window.sendToDefaultView($ngRedux, $location, Auth);
  }

  return defer.promise;
}

/* eslint-disable  no-useless-escape */
const isMobile = function (userAgent) {
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4))) {
    return true;
  } else {
    return false;
  }
}
/* eslint-enable  no-useless-escape */

function dialog(x, y, url) {
  var w = window.screen.availWidth;
  var h = window.screen.availHeight;
  w = (w - x) / 2;
  h = (h - y) / 2;

  var windowOptions = "resizable=no,menubar=no,toolbar=no,status=no,scrollbars=no,location=no,menubar=no,width=" + x + ",height=" + y + ",top=" + h + ",left=" + w;
  var dialogWin = window.open(url, "cleanUp", windowOptions);
  dialogWin.blur()
  window.focus()

  return dialogWin;
}

window.onbeforeunload = function () {

  /*  
   *  COMMENTING OUT THIS SECTION UNTIL WE FIGURE OUT WHAT TO DO WITH LOGOUT
   *  USERS WILL BE REQUIRED TO CLICK THE LOGOUT BUTTON IN WT TO RELEASE LICENSE
   */

  // 0	TYPE_NAVIGATE	The page was accessed by following a link, a bookmark, a form submission, a script, or typing the URL in the address bar.
  // 1	TYPE_RELOAD	The page was accessed by clicking the Reload button or via the Location.reload() method.
  // 2	TYPE_BACK_FORWARD	The page was accessed by navigating into the history.
  // 255	TYPE_RESERVED	Any other way.

  //https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation/type

  // we don't want to logout in electron if it returns 0 on refresh
  //const electronRefresh = window.dl.isElectron && performance.navigation.type === 0;

  //if (!electronRefresh && performance.navigation.type !== 1) {
  //  localStorage.removeItem('sessionId');
  //  this.navigator.sendBeacon('/api/authentication/logout')
  //}
}
